import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { RoutesFun } from '../../schemas/index';
// import azureIcon from '../../assets/images/azure-icon.png';
// import awsIcon from '../../assets/images/aws-icon.png';
import { useSelector } from 'react-redux';
import { userState } from '../../store/index';
import './Navigation.css';
import { FEATURES } from '../../utils/constants';
import { ReactComponent as SecurityImg } from '../../assets/navigationSvg/security.svg';
import { ReactComponent as ReportImg } from '../../assets/navigationSvg/reports.svg';
import { ReactComponent as CostAnalysisImg } from '../../assets/navigationSvg/cost-analysis.svg';
import { ReactComponent as CostBreakupImg } from '../../assets/navigationSvg/cost-breakup.svg';
// import { ReactComponent as DataTransferImg } from '../../assets/navigationSvg/data-transfer.svg';
// import { ReactComponent as DatabaseImg } from '../../assets/navigationSvg/database.svg';
import { ReactComponent as InstanceCostImg } from '../../assets/navigationSvg/instance-cost.svg';
import { ReactComponent as ContainersImg } from '../../assets/navigationSvg/containers.svg';
import { ReactComponent as StorageImg } from '../../assets/navigationSvg/storage.svg';
import { ReactComponent as CloudwatchImg } from '../../assets/navigationSvg/cloudwatch.svg';
import { ReactComponent as ServerlessImg } from '../../assets/navigationSvg/serverless.svg';
import { ReactComponent as AnalyticsImg } from '../../assets/navigationSvg/analytics.svg';
import { ReactComponent as NetworkContentDeliveryImg } from '../../assets/navigationSvg/network-contentdelivery.svg';
import { ReactComponent as MigrationTransferImg } from '../../assets/navigationSvg/migration-transfer.svg';
import { ReactComponent as MediaServicesImg } from '../../assets/navigationSvg/media-services.svg';
import { ReactComponent as BillingImg } from '../../assets/navigationSvg/billing.svg';
import { ReactComponent as BillingConsoleImg } from '../../assets/navigationSvg/billing-console.svg';
import { ReactComponent as AccountWiseBreakupImg } from '../../assets/navigationSvg/accountwise-breakup.svg';
import { ReactComponent as SavingImg } from '../../assets/navigationSvg/piggyBank.svg';
import { ReactComponent as ForcastImg } from '../../assets/navigationSvg/barChart.svg';
import { ReactComponent as ScheduleImg } from '../../assets/navigationSvg/calander.svg';
import { ReactComponent as UptimeMonitoring } from '../../assets/navigationSvg/UptimeMonitoring.svg';
import { ReactComponent as AdminDashboard } from '../../assets/navigationSvg/AdminDashboard.svg';
import { ReactComponent as Organizations } from '../../assets/navigationSvg/Organizations.svg';
import { ReactComponent as IdleImg } from '../../assets/navigationSvg/idle.svg';
import { ReactComponent as RightSizingImg } from '../../assets/navigationSvg/rightSizing.svg';
import { ReactComponent as Billing } from '../../assets/navigationSvg/adminPanel-billing.svg';
import { ReactComponent as SystemHealth } from '../../assets/navigationSvg/monitoring-system-icon.svg';
import { ReactComponent as SubAdmins } from '../../assets/navigationSvg/Users.svg';
import { ReactComponent as DocSvg } from '../../assets/ICONS/docSvg.svg';
import { ReactComponent as RUMDashboard } from '../../assets/navigationSvg/RUM.svg';
import { ReactComponent as SystemHealthMonitoring } from '../../assets/navigationSvg/system-health-monitoring.svg';
import { ReactComponent as ReservationImg } from '../../assets/navigationSvg/reservations.svg';
import { ReactComponent as CoverageImg } from '../../assets/navigationSvg/coverage.svg';
import { ReactComponent as ComparisonReport } from '../../assets/navigationSvg/comparisonReport.svg';
import { ReactComponent as SummaryImg } from '../../assets/navigationSvg/summary.svg';
import { InventoryIcon } from './config';
import SidebarItem from './SideBarItem';
import { uiState } from '../../store';

export const Navigation: React.FC = () => {
  const location = useLocation();
  const { collapsed } = useSelector(uiState);
  const Routes = RoutesFun();
  const [currentPage, setCurrentPage] = React.useState('');
  const userData = useSelector(userState);
  const user = userData.userData;

  const EXPANDABLE_MENUS = {
    CostBreakup: [
      Routes.DataTransfer,
      Routes.Database,
      Routes.InstanceCost,
      Routes.Containers,
      Routes.Storage,
      Routes.Cloudwatch,
      Routes.NetworkContentDelivery,
      Routes.SecurityCostBreakup,
      Routes.Serverless,
      Routes.Analytics,
      Routes.MigrationTransfer,
      Routes.MediaServices,
    ],
    Reservations: [Routes.Coverage, Routes.Summary],
  };

  // const COST_BREAKUP_CHILD_ROUTES = [
  //   Routes.DataTransfer,
  //   Routes.Database,
  //   Routes.InstanceCost,
  //   Routes.Containers,
  //   Routes.Storage,
  //   Routes.Cloudwatch,
  //   Routes.NetworkContentDelivery,
  //   Routes.SecurityCostBreakup,
  //   Routes.Serverless,
  //   Routes.Analytics,
  //   Routes.MigrationTransfer,
  //   Routes.MediaServices,
  // ];

  // Generic function to check if any child route is active
  const isMenuActive = (
    menuKey: keyof typeof EXPANDABLE_MENUS,
    currentPath: string
  ) => {
    const childRoutes = EXPANDABLE_MENUS[menuKey];
    const mainRoute = Routes[menuKey as keyof typeof Routes];

    return (
      childRoutes.some((route) => currentPath === route) ||
      currentPath === mainRoute
    );
  };

  // Generic function to get active child route
  const getActiveChildRoute = (
    menuKey: keyof typeof EXPANDABLE_MENUS,
    currentPath: string
  ) => {
    const childRoutes = EXPANDABLE_MENUS[menuKey];
    return childRoutes.find((route) => route === currentPath);
  };

  // Generic function to determine initial expanded menu
  const getInitialExpandedMenu = (pathname: string): string | null => {
    for (const [menuKey, childRoutes] of Object.entries(EXPANDABLE_MENUS)) {
      const mainRoute = Routes[menuKey as keyof typeof Routes];
      const allRoutes = [mainRoute, ...childRoutes];

      if (allRoutes.some((route) => pathname === route)) {
        return menuKey;
      }
    }
    return null;
  };

  const initialExpandedMenu = React.useMemo(() => {
    return getInitialExpandedMenu(location.pathname);
  }, [location.pathname]);

  const [expandedMenuKey, setExpandedMenuKey] = React.useState<string | null>(
    initialExpandedMenu
  );

  // const isCostBreakupActive =
  //   COST_BREAKUP_CHILD_ROUTES.some((route) => currentPage === route) ||
  //   currentPage === Routes.CostBreakup;

  // const costBreakupActiveChildRoute = COST_BREAKUP_CHILD_ROUTES.find(
  //   (route) => route === currentPage
  // );

  // const initialExpandedMenu = React.useMemo(() => {
  //   const isUnderCostBreakup = [
  //     Routes.CostBreakup,
  //     ...COST_BREAKUP_CHILD_ROUTES,
  //   ].some((route) => location.pathname === route);

  //   return isUnderCostBreakup ? 'CostBreakup' : null;
  // }, [location.pathname]);

  // const [expandedMenuKey, setExpandedMenuKey] = React.useState<string | null>(
  //   initialExpandedMenu
  // );

  // const selectedAccount = useSelector(accountState).selectedAccount;
  // const isAccountSelected = useSelector(accountState).isAccountSelected;

  const isSameLinkHandler = (route: string) =>
    new RegExp(`(^|/)${route}(/|$)`).test(currentPage);

  // useEffect(() => {
  //   setCurrentPage(location.pathname);

  //   const isUnderCostBreakup = [
  //     Routes.CostBreakup,
  //     ...COST_BREAKUP_CHILD_ROUTES,
  //   ].some((route) => location.pathname === route);

  //   if (isUnderCostBreakup && !collapsed) {
  //     setExpandedMenuKey('CostBreakup');
  //   } else if (!isUnderCostBreakup) {
  //     setExpandedMenuKey(null);
  //   }
  // }, [location.pathname, collapsed]);

  useEffect(() => {
    setCurrentPage(location.pathname);

    const newExpandedMenu = getInitialExpandedMenu(location.pathname);

    if (newExpandedMenu && !collapsed) {
      setExpandedMenuKey(newExpandedMenu);
    } else if (!newExpandedMenu) {
      setExpandedMenuKey(null);
    }
  }, [location.pathname, collapsed]);

  return (
    <React.Fragment>
      {/* for admin role */}
      {user?.RoleId === 1 ? (
        <ul>
          <SidebarItem
            featureKey="AdminDashboard"
            isActive={currentPage === Routes.AdminDashboard}
            icon={<AdminDashboard width={20} height={20} />}
            route={Routes.AdminDashboard}
          />
          <SidebarItem
            featureKey="AllOrganizations"
            isActive={currentPage === Routes.AllOrganizations}
            icon={<Organizations width={20} height={20} />}
            route={Routes.AllOrganizations}
          />
          <SidebarItem
            featureKey="AdminPanelBilling"
            isActive={currentPage === Routes.AdminPanelBilling}
            icon={<Billing width={20} height={20} />}
            route={Routes.AdminPanelBilling}
          />
          <SidebarItem
            featureKey="SystemHealth"
            isActive={currentPage === Routes.SystemHealth}
            icon={<SystemHealth width={20} height={20} />}
            route={Routes.SystemHealth}
          />
          <SidebarItem
            featureKey="SubAdmins"
            isActive={currentPage === Routes.SubAdmins}
            icon={<SubAdmins width={20} height={20} />}
            route={Routes.SubAdmins}
          />
          {/* <SidebarItem
            featureKey="ManagePlan"
            isActive={currentPage === Routes.ManagePlan}
            icon={<IdleImg width={20} height={20} />}
            route={Routes.ManagePlan}
          /> */}
        </ul>
      ) : (
        // for user roles
        <ul>
          {/* <li className={`platformIcon ${!isAccountSelected ? 'd-none' : ''}`}>
            {selectedAccount?.CloudProvider.toUpperCase() === 'AZURE' ? (
              <img src={azureIcon} alt="" width="40" />
            ) : selectedAccount?.CloudProvider.toUpperCase() === 'AWS' ? (
              <img src={awsIcon} alt="" width="40" />
            ) : (
              <img src={azureIcon} alt="" width="40" />
            )}
          </li> */}
          {/* <SidebarItem
            featureKey="Inventory"
            feature={FEATURES.INVENTORY}
            route={Routes.Inventories}
            isActive={
              currentPage.split('/')[2] === Routes.Inventories.split('/')[2]
            }
            icon={InventoryIcon}
            /> */}
          <SidebarItem
            featureKey="Inventory"
            feature={FEATURES.COST_FORECASTING}
            route={Routes.ServicesCost}
            isActive={
              currentPage.split('/')[2] === Routes.ServicesCost.split('/')[2]
            }
            icon={InventoryIcon}
          />
          {/* <SidebarItem
            featureKey="IdleResources"
            feature={FEATURES.IDLE_RESOURCES}
            route={Routes.IdleInstance}
            isActive={isSameLinkHandler(Routes.IdleInstance)}
            icon={<IdleImg />}
          />
          <SidebarItem
            featureKey="RightSizing"
            feature={FEATURES.RIGHTSIZING}
            route={Routes.RightSizing}
            isActive={
              currentPage.split('/')[2] === Routes.RightSizing.split('/')[2]
            }
            icon={<RightSizingImg />}
          />
          <SidebarItem
            featureKey="ScheduleInstances"
            feature={FEATURES.SCHEDULE_INSTANCES}
            route={Routes.ScheduleVM}
            isActive={currentPage === Routes.ScheduleVM}
            icon={<ScheduleImg width={20} height={20} />}
          /> */}
          <SidebarItem
            featureKey="CostForecasting"
            feature={FEATURES.COST_FORECASTING}
            route={Routes.CostForecasting}
            isActive={
              currentPage.split('/')[2] === Routes.CostForecasting.split('/')[2]
            }
            icon={<ForcastImg width={20} height={20} />}
          />
          <SidebarItem
            featureKey="CostBreakup"
            feature={FEATURES.COST_FORECASTING}
            route={Routes.CostBreakup}
            isActive={isMenuActive('CostBreakup', currentPage)}
            icon={<CostBreakupImg width={20} height={20} />}
            expandedMenuKey={expandedMenuKey}
            setExpandedMenuKey={setExpandedMenuKey}
            menuKey="CostBreakup"
          >
            {/* <SidebarItem
            featureKey="CostBreakup"
            feature={FEATURES.COST_FORECASTING}
            route={Routes.CostBreakup}
            isActive={isCostBreakupActive || currentPage === Routes.CostBreakup}
            icon={<CostBreakupImg width={20} height={20} />}
            expandedMenuKey={expandedMenuKey}
            setExpandedMenuKey={setExpandedMenuKey}
          > */}
            {/* <SidebarItem
              featureKey="DataTransfer"
              feature={FEATURES.COST_FORECASTING}
              route={Routes.DataTransfer}
              isActive={currentPage === Routes.DataTransfer && costBreakupActiveChildRoute === Routes.DataTransfer}
              icon={<DataTransferImg width={20} height={20} />}
            />*/}
            {/* <SidebarItem
              featureKey="Database"
              feature={FEATURES.COST_FORECASTING}
              route={Routes.Database}
              isActive={
                currentPage === Routes.Database &&
                getActiveChildRoute('CostBreakup', currentPage) ===
                  Routes.Database
              }
              icon={<DatabaseImg width={20} height={20} />}
            /> */}
            <SidebarItem
              featureKey="InstanceCost"
              feature={FEATURES.COST_FORECASTING}
              route={Routes.InstanceCost}
              isActive={
                currentPage === Routes.InstanceCost &&
                getActiveChildRoute('CostBreakup', currentPage) ===
                  Routes.InstanceCost
              }
              icon={<InstanceCostImg width={20} height={20} />}
            />
            <SidebarItem
              featureKey="Containers"
              feature={FEATURES.COST_FORECASTING}
              route={Routes.Containers}
              isActive={
                currentPage === Routes.Containers &&
                getActiveChildRoute('CostBreakup', currentPage) ===
                  Routes.Containers
              }
              icon={<ContainersImg width={20} height={20} />}
            />
            <SidebarItem
              featureKey="Storage"
              feature={FEATURES.COST_FORECASTING}
              route={Routes.Storage}
              isActive={
                currentPage === Routes.Storage &&
                getActiveChildRoute('CostBreakup', currentPage) ===
                  Routes.Storage
              }
              icon={<StorageImg width={20} height={20} />}
            />
            <SidebarItem
              featureKey="Cloudwatch"
              feature={FEATURES.COST_FORECASTING}
              route={Routes.Cloudwatch}
              isActive={
                currentPage === Routes.Cloudwatch &&
                getActiveChildRoute('CostBreakup', currentPage) ===
                  Routes.Cloudwatch
              }
              icon={<CloudwatchImg width={20} height={20} />}
            />
            <SidebarItem
              featureKey="NetworkContentDelivery"
              feature={FEATURES.COST_FORECASTING}
              route={Routes.NetworkContentDelivery}
              isActive={
                currentPage === Routes.NetworkContentDelivery &&
                getActiveChildRoute('CostBreakup', currentPage) ===
                  Routes.NetworkContentDelivery
              }
              icon={<NetworkContentDeliveryImg width={20} height={20} />}
            />
            <SidebarItem
              featureKey="SecurityCostBreakup"
              feature={FEATURES.COST_FORECASTING}
              route={Routes.SecurityCostBreakup}
              isActive={
                currentPage === Routes.SecurityCostBreakup &&
                getActiveChildRoute('CostBreakup', currentPage) ===
                  Routes.SecurityCostBreakup
              }
              icon={<SecurityImg width={20} height={20} />}
            />
            <SidebarItem
              featureKey="Serverless"
              feature={FEATURES.COST_FORECASTING}
              route={Routes.Serverless}
              isActive={
                currentPage === Routes.Serverless &&
                getActiveChildRoute('CostBreakup', currentPage) ===
                  Routes.Serverless
              }
              icon={<ServerlessImg width={20} height={20} />}
            />
            <SidebarItem
              featureKey="Analytics"
              feature={FEATURES.COST_FORECASTING}
              route={Routes.Analytics}
              isActive={
                currentPage === Routes.Analytics &&
                getActiveChildRoute('CostBreakup', currentPage) ===
                  Routes.Analytics
              }
              icon={<AnalyticsImg width={20} height={20} />}
            />
            <SidebarItem
              featureKey="MigrationTransfer"
              feature={FEATURES.COST_FORECASTING}
              route={Routes.MigrationTransfer}
              isActive={
                currentPage === Routes.MigrationTransfer &&
                getActiveChildRoute('CostBreakup', currentPage) ===
                  Routes.MigrationTransfer
              }
              icon={<MigrationTransferImg width={18} height={20} />}
            />
            <SidebarItem
              featureKey="MediaServices"
              feature={FEATURES.COST_FORECASTING}
              route={Routes.MediaServices}
              isActive={
                currentPage === Routes.MediaServices &&
                getActiveChildRoute('CostBreakup', currentPage) ===
                  Routes.MediaServices
              }
              icon={<MediaServicesImg width={20} height={20} />}
            />
          </SidebarItem>
          <SidebarItem
            featureKey="Reservations"
            feature={FEATURES.COST_FORECASTING} // Make sure this exists in your FEATURES constant
            route={Routes.Reservations}
            isActive={isMenuActive('Reservations', currentPage)}
            icon={<ReservationImg width={20} height={20} />} // You'll need to import this icon
            expandedMenuKey={expandedMenuKey}
            setExpandedMenuKey={setExpandedMenuKey}
            menuKey="Reservation"
          >
            {/* Coverage as child item */}
            <SidebarItem
              featureKey="Coverage"
              feature={FEATURES.COST_FORECASTING} // Make sure this exists in your FEATURES constant
              route={Routes.Coverage}
              isActive={
                currentPage === Routes.Coverage &&
                getActiveChildRoute('Reservations', currentPage) ===
                  Routes.Coverage
              }
              icon={<CoverageImg width={20} height={20} />} // You'll need to import this icon
            />
            <SidebarItem
              featureKey="Summary"
              feature={FEATURES.COST_FORECASTING} // Make sure this exists in your FEATURES constant
              route={Routes.Summary}
              isActive={
                currentPage === Routes.Summary &&
                getActiveChildRoute('Reservations', currentPage) ===
                  Routes.Summary
              }
              icon={<SummaryImg width={20} height={20} />} // You'll need to import this icon
            />
            {/* Add more child items here if needed */}
            {/* 
            <SidebarItem
              featureKey="ReservationReports"
              feature={FEATURES.RESERVATION_REPORTS}
              route={Routes.ReservationReports}
              isActive={
                currentPage === Routes.ReservationReports &&
                getActiveChildRoute('Reservation', currentPage) === Routes.ReservationReports
              }
              icon={<ReportImg width={20} height={20} />}
            />
            */}
          </SidebarItem>
          {/* <SidebarItem
            featureKey="CostSaving"
            feature={FEATURES.COST_SAVING}
            route={Routes.CostSaving}
            isActive={currentPage === Routes.CostSaving}
            icon={<SavingImg width={20} height={20} />}
          /> */}
          {/* <SidebarItem
            featureKey="BillingSimplified"
            feature={FEATURES.COST_FORECASTING}
            route={Routes.Invoice}
            isActive={isSameLinkHandler(Routes.Invoice)}
            icon={<BillingImg width={20} height={20} />}
          /> */}
          <SidebarItem
            featureKey="BillingConsole"
            feature={FEATURES.COST_FORECASTING}
            route={Routes.BillingConsole}
            isActive={isSameLinkHandler(Routes.BillingConsole)}
            icon={<BillingConsoleImg width={20} height={20} />}
          />
          <SidebarItem
            featureKey="AccountWiseBreakup"
            feature={FEATURES.COST_FORECASTING}
            route={Routes.AccountWiseBreakup}
            isActive={isSameLinkHandler(Routes.AccountWiseBreakup)}
            icon={<AccountWiseBreakupImg width={20} height={20} />}
          />
          <SidebarItem
            featureKey="SecurityScan"
            feature={FEATURES.SECURITY_SCAN}
            route={Routes.SecurityScan}
            isActive={currentPage === Routes.SecurityScan}
            icon={<SecurityImg width={20} height={20} />}
          />
          <SidebarItem
            featureKey="ServiceReports"
            feature={FEATURES.COST_FORECASTING}
            route={Routes.ServicesReports}
            isActive={currentPage === Routes.ServicesReports}
            icon={<ReportImg width={20} height={20} />}
          />
          <SidebarItem
            featureKey="ComparisonReports"
            feature={FEATURES.COST_FORECASTING}
            route={Routes.ComparisonReports}
            isActive={currentPage === Routes.ComparisonReports}
            icon={<ComparisonReport width={20} height={20} />}
          />
          <SidebarItem
            featureKey="CostAnalysis"
            feature={FEATURES.COST_FORECASTING}
            route={Routes.CostAnalysis}
            isActive={currentPage === Routes.CostAnalysis}
            icon={<CostAnalysisImg width={20} height={20} />}
          />
          <SidebarItem
            featureKey="UptimeMonitoring"
            feature={FEATURES.UPTIME_MONITORING}
            route={Routes.UptimeMonitoring}
            isActive={currentPage.startsWith(Routes.UptimeMonitoring)}
            icon={<UptimeMonitoring width={20} height={20} />}
          />
          {/* System Health Monitoring */}
          <SidebarItem
            featureKey="HealthMonitoring"
            feature={FEATURES.HEALTH_MONITORING}
            route={Routes.SystemHealthMonitoring}
            isActive={currentPage === Routes.SystemHealthMonitoring}
            icon={<SystemHealthMonitoring width={20} height={20} />}
          />
          {/* RUM monitoring */}
          <SidebarItem
            featureKey="RealUserMonitoring"
            feature={FEATURES.REAL_USER_MONITORING}
            route={Routes.RealUserMonitoring}
            isActive={currentPage === Routes.RealUserMonitoring}
            icon={<RUMDashboard width={20} height={20} />}
          />
          {/* //upload docs */}
          <SidebarItem
            featureKey="UploadedDocuments"
            feature={FEATURES.UPLOADED_DOCUMENTS}
            route={Routes.UploadedDocuments}
            isActive={currentPage === Routes.UploadedDocuments}
            icon={<DocSvg width={20} height={20} />}
          />
          <SidebarItem
            featureKey="AdminDashboard"
            feature={FEATURES.ADMIN_DASHBOARD}
            isActive={currentPage === Routes.AdminDashboard}
            icon={<AdminDashboard width={20} height={20} />}
            route={Routes.AdminDashboard}
          />
          <SidebarItem
            featureKey="AllOrganizations"
            feature={FEATURES.ALL_ORGANIZATIONS}
            isActive={currentPage === Routes.AllOrganizations}
            icon={<Organizations width={20} height={20} />}
            route={Routes.AllOrganizations}
          />
          <SidebarItem
            featureKey="AdminPanelBilling"
            feature={FEATURES.ADMIN_PANEL_BILLING}
            isActive={currentPage === Routes.AdminPanelBilling}
            icon={<Billing width={20} height={20} />}
            route={Routes.AdminPanelBilling}
          />
          <SidebarItem
            featureKey="SystemHealth"
            feature={FEATURES.SYSTEM_HEALTH}
            isActive={currentPage === Routes.SystemHealth}
            icon={<SystemHealth width={20} height={20} />}
            route={Routes.SystemHealth}
          />
        </ul>
      )}
    </React.Fragment>
  );
};
